import { map as rxjsmap } from 'rxjs';



import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { BaseServices } from './../../kuba.services';
import { HomePage } from './../models/businessHomepage';
import { HttpClient, HttpHeaderResponse } from '@angular/common/http';

@Injectable()
export class BusinessHomepageService {
    constructor(private http: HttpClient) {}
    getHomepageByBusinessId(bid: number) {
        return this.http
            .get(environment.BASE_URL + '/homepages/homepagelist/' + bid, ).pipe(rxjsmap(result => result));
    }
    getHomepageById(id: number) {
        return this.http
            .get(environment.BASE_URL + '/homepages/homepage/' + id, ).pipe(rxjsmap(result => result));
    }
    createHomepage(homepage: HomePage) {
        return this.http
            .post(
                environment.BASE_URL + '/homepages/homepage/',
                homepage,

            ).pipe(rxjsmap(result => result));
    }

    updateHomepage(id: number, homepage: HomePage) {
        return this.http
            .put(
                environment.BASE_URL + '/homepages/homepage/',
                homepage,

            ).pipe(rxjsmap(result => result));
    }

    deleteById(id: number) {
        return this.http
            .delete<HttpHeaderResponse>(environment.BASE_URL + '/homepages/homepagedelete/' + id, )
            .toPromise()
            .then((response: HttpHeaderResponse) => {
                return response;
            });
    }
    checkExistingLink(link: string) {
        return this.http
            .get(environment.BASE_URL + '/homepages/check-link/' + link, ).pipe(rxjsmap(result => result));
    }
}
